<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a"><a id="page_9"><span class="txbf">Chapter 1</span></a></h2><a id="page_9">
<h2 class="h2sub"><span class="txbf">The Basics of Music</span></h2>
<p class="noindentr">Whether you are new to the study of music or are adept at reading and playing music, you need to have a firm grasp of the basics and an appreciation of its rich compositional history to understand music theory. With that in mind, this chapter offers an overview of the basic musical terms and concepts upon which music theory is built, as well as a brief history of musical styles.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch01.vue?5f6bfad1